module.exports = __webpack_public_path__ + "3c29319b58373fd671c13cc7d38b479b.pdf";